<template>
  <li :class="classes" @click.stop="$_onMenuItemClick">
    <slot></slot>
  </li>
</template>
<script>
import { PREFIX_MENU_CLASS } from './constants'
import Emitter from '../../mixins/emitter'

export default {
  name: 'MenuItem',
  mixins: [Emitter],
  props: {
    name: {
      type: [String, Number],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: false
    }
  },
  computed: {
    classes() {
      return [
        `${PREFIX_MENU_CLASS}__item`,
        {
          [`${PREFIX_MENU_CLASS}__item--checked`]: this.active,
          [`${PREFIX_MENU_CLASS}__item--disabled`]: this.disabled
        }
      ]
    }
  },
  mounted() {
    this.$on('on-update-active-name', name => {
      if (this.name === name) {
        this.active = true
        this.dispatch('TSubmenu', 'on-update-active-name', true)
      } else {
        this.active = false
      }
    })
  },
  methods: {
    // 添加私有方法
    $_onMenuItemClick() {
      if (this.disabled) return

      let parent = this.$parent
      let name = parent.$options.name
      // 筛选出sub-menu组件
      while (parent && (!name || name !== 'TSubmenu')) {
        parent = parent.$parent
        if (parent) name = parent.$options.name
      }
      // 当sub-menu组件存在时
      if (parent) {
        this.dispatch('TSubmenu', 'menu-item-select', this.name)
      } else {
        this.dispatch('TMenu', 'menu-item-select', this.name)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// menu-item.vue?65d0d0b2